// TODO: Reconcile with RIDS & Action Service
export default class RouteResolverService {
  constructor($stateParams, QueryParamService, $rootScope, EventService) {
    'ngInject';
    Object.assign(this, {$stateParams, QueryParamService});
    this.es = EventService;
    $rootScope.$on('$locationChangeStart', () => this.locationChangeStart());
  }

  get templateId() {
    return this.QueryParamService.getRawParam('templateId') || this.$stateParams.templateId;
  }
  
  locationChangeStart() {
    this.es.dispatchEvent(this.es.actions.LOCATION_CHANGED, this.$stateParams);
  }

}